export default IconTransferOut => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-transfer-out" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 19v2h16v-14l-8 -4l-8 4v2" />
  <path d="M13 14h-9" />
  <path d="M7 11l-3 3l3 3" />
</svg>`;